<ng-container [ngSwitch]="btn.type">
    <!-- the same view can be shown in more than one case -->
    <div *ngSwitchCase="'close'">
        <button pButton type="button" [label]="btn.title" class="p-button-{{btn.color}}" (click)="emitOnClick('close')"></button>
    </div>
    <div *ngSwitchCase="'internal'">
        <button pButton type="button" [label]="btn.title" class="p-button-{{btn.color}}" [routerLink]="btn.link" icon="fa-solid fa-arrow-right-long" iconPos="right" (click)="emitOnClick('internal')"></button>
    </div>
    <div *ngSwitchCase="'external'">
        <a pButton type="button" [label]="btn.title" class="p-button-{{btn.color}}" icon="fa-solid fa-arrow-right-long" iconPos="right" [href]="btn.link" target="_blank" (click)="emitOnClick('openExternal')"></a>
    </div>
    <!--default case when there are no matches -->
    <div *ngSwitchDefault>...</div>
</ng-container>
